/// <amd-module name="typeahead/features/CurrentLocationSuggester" />
import {GeolocationDataProvider} from "typeahead/core/geolocation/GeolocationDataProvider";
import {GeolocationMetricLogger} from "typeahead/core/geolocation/logging/GeolocationMetricLogger";
import {MercuryGeolocationViewController} from "typeahead/core/geolocation/MercuryGeolocationViewController";
import {IDataProviderResponse} from "typeahead/core/IDataProvider";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IFocusSuggester} from "typeahead/core/IFocusSuggester";
import {ISuggesterResponse} from "typeahead/core/ISuggester";
import {FormLoadedMessage} from "typeahead/core/message/FormLoadedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {SuggesterId} from "typeahead/core/SuggestionsAggregator";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [{
    experiment: {
        id: 11852,
        name: "CWTA_MobileFirstCurrentLocation",
        value: 1,
    },
    tabs: ["hotel"],
}];
const applicableClients: string[] = ["Homepage", "HotelsLandingPage"];

export class CurrentLocationSuggester implements IPageLoadHandler, IFocusSuggester, IExperimentalFeature {

    private geolocationDataProvider: GeolocationDataProvider;
    private mercuryGeolocationViewController: MercuryGeolocationViewController;
    private geolocationMetricLogger: GeolocationMetricLogger;

    public handlePageLoad(options: any, context: IContext): JQueryPromise<undefined> {
        let deferred: JQueryDeferred<undefined> = $.Deferred();
        if (applicableClients.indexOf(context.clientId) > -1) {
            TypeaheadMessage.subscribe(FormLoadedMessage.getTopic(), (topic: string, message: FormLoadedMessage) => {
                context.tab = message.getTab();
                if (TypeaheadUtils.isWithinMobileBreakpoint()) {
                    ExecutionHelper.shouldExecute(context, configuration).done((shouldExecute) => {
                        if (shouldExecute) {
                            this.initialize();
                            this.mercuryGeolocationViewController.updateView(message.getTab());
                        }
                    });
                }
            });

        }
        return deferred.resolve(undefined).promise();
    }

    public suggestOnFocus(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        return this.suggest(options, context);
    }

    public suggest(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        let deferred: JQueryDeferred<ISuggesterResponse> = $.Deferred();
        let emptySuggesterResponse: ISuggesterResponse = {id: this.getId(), results: []};
        ExecutionHelper.shouldExecute(context, configuration).done((shouldExecute) => {
            if (shouldExecute) {
                this.initialize();
                this.geolocationDataProvider.fetchData(options).done((response: IDataProviderResponse) => {
                    deferred.resolve({id: this.getId(), results: response.results});
                }).fail(() => {
                    deferred.resolve(emptySuggesterResponse);
                });
            } else {
                deferred.resolve(emptySuggesterResponse);
            }
        }).fail(() => {
            deferred.resolve(emptySuggesterResponse);
        });
        return deferred.promise();
    }

    public getId(): SuggesterId {
        return SuggesterId.CurrentLocationSuggester;
    }

    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    private initialize(): void {
        if (!this.geolocationDataProvider) {
            this.geolocationDataProvider = new GeolocationDataProvider();
            this.mercuryGeolocationViewController = new MercuryGeolocationViewController(this.geolocationDataProvider);
            this.geolocationMetricLogger = new GeolocationMetricLogger();
        }
    }
}
